import { render, staticRenderFns } from "./categorySourcing.vue?vue&type=template&id=0d6cc8aa&scoped=true"
import script from "./categorySourcing.vue?vue&type=script&lang=js"
export * from "./categorySourcing.vue?vue&type=script&lang=js"
import style0 from "./categorySourcing.vue?vue&type=style&index=0&id=0d6cc8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6cc8aa",
  null
  
)

export default component.exports